import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-637b025a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "testimonials",
  ref: "testimonials",
  class: "testimonials"
}
const _hoisted_2 = {
  key: 0,
  class: "landing-page-container"
}
const _hoisted_3 = { class: "testimonials-title" }
const _hoisted_4 = { class: "p-d-flex p-justify-between influencer-say-row" }
const _hoisted_5 = { class: "p-d-flex influencer-info-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons quote" }, "format_quote", -1))
const _hoisted_7 = { class: "p-ml-2 influencer-name-info" }
const _hoisted_8 = { class: "p-d-flex influencer-name-star-wrap" }
const _hoisted_9 = { class: "influencer-name" }
const _hoisted_10 = { class: "star-margin-left" }
const _hoisted_11 = { class: "yt-influencers" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "testimonials-adjust" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "landing-page-container"
}
const _hoisted_17 = { class: "testimonials-title" }
const _hoisted_18 = { class: "influencer-say-row is-mobile" }
const _hoisted_19 = { class: "info-wrap" }
const _hoisted_20 = { class: "testimonials-adjust" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "influencer-info" }
const _hoisted_23 = { class: "influencer-name" }
const _hoisted_24 = { class: "yt-influencers" }
const _hoisted_25 = { class: "star-margin-left" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-left",
  style: {"color":"#fff","font-size":"30px","height":"30px","width":"30px","background":"transparent"}
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-right",
  style: {"color":"#fff","font-size":"30px","height":"30px","width":"30px","background":"transparent"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_motion46div = _resolveComponent("motion.div")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.reviewList[_ctx.currentReview].title), 1),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives((_openBlock(), _createBlock(_component_motion46div, {
              initial: { opacity: 0, x: -50 },
              enter: { opacity: 1, x: 0, y: 0 },
              variants: { custom: { scale: 2 } },
              delay: 10,
              duration: 1200,
              class: "desktop-motion-div"
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_motion46div, {
                  initial: { opacity: 0, x: -50 },
                  enter: { opacity: 1, x: 0, y: 0 },
                  variants: { custom: { scale: 2 } },
                  delay: 10,
                  duration: 1200,
                  key: _ctx.currentReview
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.reviewList[_ctx.currentReview].name), 1),
                          _createElementVNode("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewList[_ctx.currentReview].star, (index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: index,
                                class: "material-icons star"
                              }, " star "))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.reviewList[_ctx.currentReview].designation), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "influencer-text",
                      innerHTML: _ctx.formattedDescription
                    }, null, 8, _hoisted_12)
                  ]),
                  _: 1
                })), [
                  [_directive_motion]
                ]),
                _createElementVNode("button", {
                  class: "join-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLoginClick && _ctx.handleLoginClick(...args)))
                }, "JOIN NOW")
              ]),
              _: 1
            })), [
              [_directive_motion]
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allImage, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_ctx.handleChangeReview(index))
                }, [
                  _createElementVNode("img", {
                    src: image,
                    class: "testimonials-image",
                    alt: "influencer avatar",
                    draggable: "false",
                    style: _normalizeStyle({ filter: `grayscale(${index === _ctx.currentReview ? 0 : 1})` })
                  }, null, 12, _hoisted_15)
                ], 8, _hoisted_14))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.reviewList[_ctx.currentReview].title), 1),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, [
              _createVNode(_component_Carousel, {
                value: _ctx.reviewList,
                numVisible: 1,
                numScroll: 1,
                circular: true,
                autoplayInterval: 700000,
                showIndicators: false,
                showNavigators: true
              }, {
                item: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("img", {
                        src: _ctx.allImage[slotProps.index],
                        class: "testimonials-image",
                        alt: "influencer avatar",
                        style: _normalizeStyle({ filter: `grayscale(${0})` })
                      }, null, 12, _hoisted_21)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(slotProps.data.name), 1),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(slotProps.data.designation), 1),
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.star, (index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: "material-icons star"
                          }, " star "))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "influencer-text",
                    innerHTML: slotProps.data.description.replace(/\n/g, '<br>')
                  }, null, 8, _hoisted_26)
                ]),
                previousicon: _withCtx(() => [
                  _hoisted_27
                ]),
                nexticon: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("button", {
              class: "join-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLoginClick && _ctx.handleLoginClick(...args)))
            }, "JOIN NOW")
          ])
        ]))
  ], 512))
}